import React from 'react';
import './LanguageSelector.scss';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { useTranslation } from 'react-i18next';
import CONSTANTS from '../PhaserApp/CONSTANTS/CONSTANTS';
import { SelectChangeEvent } from '@mui/material/Select';
import usePractitionerControlsContext from '../../hooks/usePractitionerControlsContext/usePractitionerControlsContext';
import Tooltip from '../Tooltip/Tooltip';

const languageOptions = [
  { key: 'en', text: 'English', value: 'EN', icon: 'assets/icons/en.svg', iso: 'en-us' },
  { key: 'nl', text: 'Nederlands', value: 'NL', icon: 'assets/icons/nl.svg', iso: 'nl' },
  { key: 'de', text: 'Deutsch', value: 'DE', icon: 'assets/icons/de.svg', iso: 'de' },
  { key: 'uk', text: 'Ukrainian', value: 'UA', icon: 'assets/icons/ua.svg', iso: 'uk' },
];

interface LanguageSelectorProps {
  size?: string;
  isMedia?: boolean;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ size = 'small', isMedia }) => {
  const { t, i18n } = useTranslation();
  const { selectedOption, setSelectedOption } = usePractitionerControlsContext();
  CONSTANTS.language = selectedOption;

  const handleSelect = async (event: SelectChangeEvent<string>) => {
    const newLang = event.target.value;
    setSelectedOption(newLang);
    await i18n.changeLanguage(newLang);
  };

  return (
    <Tooltip title={t('language') as string} placement="left">
      <FormControl>
        <Select
          className={`language-picker `}
          value={selectedOption}
          onChange={handleSelect}
          renderValue={() => {
            return (
              <img
                className={'icon'}
                height={20}
                width={20}
                src={languageOptions.find(o => o.key === selectedOption)?.icon}
                alt={''}
              />
            );
          }}
        >
          {languageOptions.map((option: any) => (
            <MenuItem value={option.key} key={option.key}>
              <img className={'icon'} height={20} width={20} src={option.icon} alt={''} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Tooltip>
  );
};

export default LanguageSelector;
